module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "menubar"
    }
  }, [_c('b-navbar', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-light d-none d-sm-block"
  }, [_c('b-navbar-nav', [_c('b-navbar-brand', {
    staticClass: "navbar-brand"
  }, [_c('b-link', {
    staticStyle: {
      "color": "black",
      "text-decoration": "none"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Concept")])], 1), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalrules",
      modifiers: {
        "modalrules": true
      }
    }]
  }, [_vm._v("\n        Règles du jeu\n      ")]), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalplaymultiplayers",
      modifiers: {
        "modalplaymultiplayers": true
      }
    }]
  }, [_vm._v("\n        Jeu live\n      ")]), _vm._v(" "), _c('b-nav-item', {
    on: {
      "click": function($event) {
        return _vm.launchPlaySolo()
      }
    }
  }, [_vm._v("\n        Jeu tour à tour\n      ")]), _vm._v(" "), (['local', 'allPlayersMode', 'boardCreation'].indexOf(_vm.gameMode) !== -1) ? _c('b-nav-item', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\n        Réinitialiser le plateau\n      ")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "https://jrmie818423.typeform.com/to/Kf9Ux6",
      "target": "_blank"
    }
  }, [_vm._v("\n        Contribuer "), _c('sup', [_c('font-awesome-icon', {
    attrs: {
      "icon": "external-link-alt"
    }
  })], 1)]), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalabout",
      modifiers: {
        "modalabout": true
      }
    }],
    staticClass: "d-md-none"
  }, [_vm._v("\n        A propos\n      ")]), _vm._v(" "), (!_vm.user) ? _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modallogin",
      modifiers: {
        "modallogin": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "user-circle",
      "size": "lg"
    }
  })], 1)], 1) : _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": _vm.user.displayName,
      "right": ""
    }
  }, [_c('b-dropdown-item', [_vm._v(_vm._s(_vm.displayGameMode))]), _vm._v(" "), (_vm.gameModeMultiplayers) ? _c('b-dropdown-item', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.showModalMultiplayers()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentGameRoom) + " \n              "), (_vm.gameRooms[_vm.currentGameRoom]) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                ("), _c('font-awesome-icon', {
    attrs: {
      "icon": "male"
    }
  }), _vm._v(" x " + _vm._s(_vm.gameRooms[_vm.currentGameRoom]['players'].length) + ")\n              ")], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Profile'
        })
      }
    }
  }, [_vm._v("Mon profil")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.$auth.logout()
      }
    }
  }, [_vm._v("Se déconnecter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-sm-none",
    staticStyle: {
      "line-height": "1.3em"
    }
  }, [_c('b-navbar', {
    staticClass: "navbar navbar-expand-lg navbar-dark bg-dark",
    attrs: {
      "id": "brand-navbar"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto mx-auto"
  }, [_c('b-navbar-brand', {
    staticClass: "navbar-brand"
  }, [_c('b-link', {
    staticStyle: {
      "color": "white",
      "text-decoration": "none"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Concept")])], 1)], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.user) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": _vm.user.displayName + _vm.displayGameModeLive,
      "right": ""
    }
  }, [(_vm.gameModeMultiplayers) ? _c('b-dropdown-item', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.showModalMultiplayers()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentGameRoom) + " \n              "), (_vm.gameRooms[_vm.currentGameRoom]) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                ("), _c('font-awesome-icon', {
    attrs: {
      "icon": "male"
    }
  }), _vm._v(" x " + _vm._s(_vm.gameRooms[_vm.currentGameRoom]['count']) + ")\n              ")], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Profile'
        })
      }
    }
  }, [_vm._v("Mon profil")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.$auth.logout()
      }
    }
  }, [_vm._v("Se déconnecter")])], 1) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modallogin",
      modifiers: {
        "modallogin": true
      }
    }],
    staticClass: "ml-auto"
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": "user-circle"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-navbar', {
    staticClass: "navbar navbar-expand-lg navbar-dark bg-dark",
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    },
    attrs: {
      "fixed": "bottom"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto mx-auto"
  }, [_c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalrules",
      modifiers: {
        "modalrules": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "book-open"
    }
  }), _c('br'), _vm._v("Règles\n        ")], 1), _vm._v(" "), (!_vm.gameMode || _vm.gameMode === 'boardPlay') ? _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalplaymultiplayers",
      modifiers: {
        "modalplaymultiplayers": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "users"
    }
  }), _c('br'), _vm._v("Jeu live\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.gameMode || _vm.gameMode === 'boardPlay') ? _c('b-nav-item', {
    on: {
      "click": function($event) {
        return _vm.launchPlaySolo()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "play-circle"
    }
  }), _c('br'), _vm._v("Jeu tour à tour\n        ")], 1) : _vm._e(), _vm._v(" "), (['boardCreation', 'local', 'allPlayersMode'].indexOf(_vm.gameMode) !== -1 || _vm.isBoardEditable) ? _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalwords",
      modifiers: {
        "modalwords": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "puzzle-piece"
    }
  }), _c('br'), _vm._v("Mots à deviner\n        ")], 1) : _vm._e(), _vm._v(" "), (['boardCreation', 'local', 'allPlayersMode'].indexOf(_vm.gameMode) !== -1 || _vm.isBoardEditable) ? _c('b-nav-item', {
    on: {
      "click": _vm.reset
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "trash-restore"
    }
  }), _c('br'), _vm._v("Réinitialiser\n        ")], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cbef0e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-bar.vue
// module id = tRwE
// module chunks = 1